/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Text } from '../../../atoms/Text/Text';
function isSafeUrl(url) {
    if (typeof url !== 'string')
        return false;
    return /^https?:\/\//i.test(url);
}
export function UpsellRenderer({ block }) {
    const upsell = block;
    const isCard = upsell.variant === 'card';
    const actions = [
        ...(isSafeUrl(upsell.learn_more_url)
            ? [
                {
                    id: 'learn-more',
                    label: upsell.learn_more_label || 'Learn More',
                    onClick: () => {
                        window.open(upsell.learn_more_url, '_blank', 'noopener,noreferrer');
                    },
                    variant: 'default'
                }
            ]
            : []),
        ...(isSafeUrl(upsell.upgrade_url)
            ? [
                {
                    id: 'upgrade',
                    label: upsell.upgrade_label || 'Upgrade',
                    onClick: () => {
                        window.open(upsell.upgrade_url, '_blank', 'noopener,noreferrer');
                    },
                    variant: 'primary'
                }
            ]
            : [])
    ];
    return (React.createElement(AIGeneralBlockCard, { className: isCard ? 'qmb-ui-upsell--card' : 'qmb-ui-upsell--inline', sections: [
            {
                label: upsell.headline,
                content: React.createElement(Text, { variant: "body" }, upsell.description)
            }
        ], footerGroups: actions.length > 0 ? [{ actions }] : [] }));
}
